import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';

export default combineReducers({
    userSummaries: simpleReducer([], {
        REQUESTING_USER_SUMMARIES: [],
        RECEIVED_USER_SUMMARIES: (a) => a.payload.summaries,
    }),

    userSummariesInTransit: simpleReducer(false, {
        REQUESTING_USER_SUMMARIES: true,
        RECEIVED_USER_SUMMARIES: false,
    }),

    mapUsername: simpleReducer('', {
        UPDATE_MAP_USERNAME: (a) => a.payload.value,
        USERNAME_LOOKUP_RESET: '',
    }),

    lookupInProgress: simpleReducer(false, {
        USERNAME_LOOKUP_STARTED: true,
        USERNAME_LOOKUP_FINISHED: false,
        USERNAME_LOOKUP_RESET: false,
    }),

    lookupFinished: simpleReducer(false, {
        USERNAME_LOOKUP_STARTED: false,
        USERNAME_LOOKUP_FINISHED: true,
        USERNAME_LOOKUP_RESET: false,
    }),

    spoofInProgress: simpleReducer(false, {
        REQUESTING_SPOOF: true,
        REQUESTED_SPOOF: false,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/user.js